import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// initial state
const state = {
    selectedFiles : [],
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
